export function isExpired(session) {
  const idTokenExpire = session.getIdToken().getExpiration();
  const currentTimeSeconds = Math.round(+new Date() / 1000);
  // console.log(`== exp ${new Date(idTokenExpire * 1000)}}`)
  return idTokenExpire < currentTimeSeconds;
}
